import renderers from "./renderers";

let nullFunction = function() {
    return null
};

export default function(callbackFun) {


    function getRendererInterpolator() {
        for (let rendererkey in renderers) {
            const renderer = renderers[rendererkey];
            if (renderer.isMounted && "interpolator" in renderer)
                return renderer.interpolator
        }
    }

    const rendererInterpolator = getRendererInterpolator();

    if (rendererInterpolator)
        rendererInterpolator.createFun(callbackFun)
    else
        callbackFun(nullFunction, nullFunction, false)

}
// }),
